export const MENU_PAGE_PATH = {
  FULL_MENU: 'api/rs-aliados-gateway/groot/partners/proxy/menu/:storeId/all',
  OUT_OF_STOCK_ITEMS:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/:storeId/?device=0',
  TURN_ON_PRODUCT:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/products/available/true',
  TURN_ON_CUSTOMIZATION:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/topping/activate',
  TURN_OFF_PRODUCT:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/products/available/false',
  TURN_OFF_CUSTOMIZATION:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/topping/deactivate',
  TURN_OFF_CUSTOMIZATION_LIST:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/topping/deactivate/list',
} as const;

// GET
// api/rs-aliados-gateway/groot/partners/proxy/menu/:storeId/all
// api/rs-aliados-gateway/groot/partners/proxy/menu/:storeId/?device=2
// api/rs-aliados-gateway/groot/partners/proxy/menu/:storeId/corridors/:corridorId/products
// api/rs-aliados-gateway/groot/partners/proxy/menu/:storeId/products/:corridorId/toppings

// PUT (turn on product)
// api/rs-aliados-gateway/groot/partners/proxy/menu/products/available/true
// payload: {"store_id":"900136324","product_id":2136347529}

// PUT (turn on topping)
// api/rs-aliados-gateway/groot/partners/proxy/menu/topping/activate
// payload: {"store_id":"900136324","topping_id":341398978}

// PUT (turn off product)
// api/rs-aliados-gateway/groot/partners/proxy/menu/products/available/false
// payload: {"deactivation_type":"DAILY","store_id":"900136324","product_id":2136347505}
// payload: {"deactivation_type":"CUSTOM","store_id":"900136324","product_id":2136347549,"out_of_stock_activation_date":"2025-01-25"}
// payload: {"deactivation_type":"PERMANENT","store_id":"900136324","product_id":2136347531}

// PUT (turn off topping)
// api/rs-aliados-gateway/groot/partners/proxy/menu/topping/deactivate
// payload: {"deactivation_type":"DAILY","store_id":"900136324","topping_id":341398977}
// payload: {"deactivation_type":"CUSTOM","store_id":"900136324","topping_id":341399024,"out_of_stock_activation_date":"2025-01-25"}
// payload: {"deactivation_type":"PERMANENT","store_id":"900136324","topping_id":341399023}
// api/rs-aliados-gateway/groot/partners/proxy/menu/topping/deactivate/list
// payload: {"store_id":900136324,"topping_id":[341399010,341399026,341398994],"deactivation_type":"DAILY"}
